import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Users, BookOpen } from 'lucide-react';
import { ContactForm } from './ContactForm';
import { CollectionPointInfoModal } from './CollectionPointInfoModal';
import { OneTrustIcon } from './OneTrustIcon';
import { OneTrustBadges } from './OneTrustBadges';

export function Home() {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800">
      {/* Hero Section */}
      <div className="w-full relative overflow-hidden">
        <div className="max-w-[2000px] mx-auto">
          <img
            src="https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/FLLR%20GUY%20PIC/hero%20section%20updated.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9GTExSIEdVWSBQSUMvaGVybyBzZWN0aW9uIHVwZGF0ZWQucG5nIiwiaWF0IjoxNzQ1MzM2MjE2LCJleHAiOjIwMjkxNjAyMTZ9.yEQReD9_GzTLQ0Cic6CT-cs2FV9xxGtVUT1wDbjiBzc"
            alt="The OneTrust Guy Hero"
            className="w-full h-auto object-cover max-h-[800px]"
          />
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-[#5e9bb8] mb-6">
            Ready to Explore OneTrust Implementation?
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
            Discover how to implement privacy management, consent handling, and compliance features with our comprehensive guides and examples.
          </p>
          <Link
            to="/privacy-center"
            className="inline-flex items-center px-8 py-4 text-lg font-medium text-white bg-[#5e9bb8] hover:bg-[#4d8299] rounded-xl transition-colors duration-300"
          >
            Explore Trust/Privacy Center
          </Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="group bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
            <Shield className="h-12 w-12 text-[#5e9bb8] mb-6 transform group-hover:scale-110 transition-transform duration-300" />
            <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white group-hover:text-[#5e9bb8] transition-colors duration-300">Privacy Management</h3>
            <p className="text-gray-600 dark:text-gray-300">Learn about OneTrust's privacy management solutions and best practices</p>
          </div>

          <div className="group bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
            <Users className="h-12 w-12 text-[#5e9bb8] mb-6 transform group-hover:scale-110 transition-transform duration-300" />
            <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white group-hover:text-[#5e9bb8] transition-colors duration-300">Consent Management</h3>
            <p className="text-gray-600 dark:text-gray-300">Master cookie consent and preference management</p>
          </div>

          <div className="group bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
            <BookOpen className="h-12 w-12 text-[#5e9bb8] mb-6 transform group-hover:scale-110 transition-transform duration-300" />
            <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white group-hover:text-[#5e9bb8] transition-colors duration-300">Training Resources</h3>
            <p className="text-gray-600 dark:text-gray-300">Access comprehensive training materials and documentation</p>
          </div>
        </div>

        {/* Badge Images Grid */}
        <OneTrustBadges />

        <div className="mt-24 privacy-center-section">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-12">
              <div className="flex justify-center items-center gap-4 mb-4">
                <h2 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#5e9bb8] to-[#499da8]">Get Started Today</h2>
                <button
                  onClick={() => setIsInfoModalOpen(true)}
                  className="relative group"
                  aria-label="Learn more about this collection point"
                >
                  <div className="absolute -inset-2 bg-[#51a071] rounded-full opacity-20 info-beacon"></div>
                  <OneTrustIcon size="lg" />
                </button>
              </div>
              <p className="text-xl text-gray-600 dark:text-gray-300">
                Interested in learning more about OneTrust implementation? Let's connect!
              </p>
            </div>
            <div className="transform hover:-translate-y-1 transition-all duration-300">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>

      <CollectionPointInfoModal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
      />
    </div>
  );
}